import { useThemeContext } from '@huggg/react-components';
import PropTypes from 'prop-types';
import { pathOr } from 'ramda';
import React from 'react';
import { Helmet } from 'react-helmet';
import { makeTitle } from 'utilities/huggg';

const hugggTitle = (isError, huggg, fallback) =>
  huggg && huggg.id && !isError ? makeTitle(huggg) : fallback;

const PageTitle = (props) => {
  const { operator } = useThemeContext();
  const { huggg, title } = props;
  const isError = pathOr(false, ['hugggState', 'error'], window);

  return (
    <Helmet>
      <title>{title || hugggTitle(isError, huggg, operator.siteTitle)}</title>
    </Helmet>
  );
};

PageTitle.propTypes = {
  huggg: PropTypes.object,
  title: PropTypes.string,
};

export default PageTitle;
